export const OPEN = 'OPEN'
export const CLOSE = 'CLOSE'
export const OPENSETTINGS = 'OPENSETTINGS'
export const CLOSESETTINGS = 'CLOSESETTINGS'
